(function () {
  'use strict';
  var serviceId = 'idleService';

  angular.module('app.services').factory(serviceId, ['$timeout', '$window', 'common',
    function ($timeout, $window, common) {
      var idleServiceFactory = {};

      var service = this;
      // Variables internas
      var idleTimeout;
      var lastActivityTime = Date.now();
      var activityEvents = ['mousemove', 'keydown', 'click'];  // Eventos que reinician el temporizador
      var EXPIRATION_INACTIVITY_TIME = 15;


      // Inicializar el servicio
      var init = function (onIdleTimeoutCallback) {
        EXPIRATION_INACTIVITY_TIME = common.localStorageService.get("EXPIRATION_INACTIVITY_TIME");
        service.onIdleTimeout = onIdleTimeoutCallback;  // Función que manejará el evento de inactividad
        addActivityListeners();
        listenToOtherTabs();
        startIdleTimer();
      };

      // Configurar listeners para los eventos de actividad
      function addActivityListeners() {
        angular.forEach(activityEvents, function (event) {
          $window.addEventListener(event, resetIdleTimer);
        });
      }

      // Eliminar listeners para los eventos de actividad
      function removeActivityListeners() {
        angular.forEach(activityEvents, function (event) {
          $window.removeEventListener(event, resetIdleTimer);
        });
      }

      // Escuchar eventos de cambio en localStorage para detectar actividad en otras pestañas
      function listenToOtherTabs() {
        $window.addEventListener("storage", handleStorageChange);
      }

      // Manejar el cambio de localStorage (cuando otras pestañas actualizan la hora de la última actividad)
      function handleStorageChange(event) {
        if (event.key === "lastActivityTime" && event.newValue) {
          var newActivityTime = parseInt(event.newValue, 10);
          if (newActivityTime > lastActivityTime) {
            // Otra pestaña está activa, reiniciar el temporizador
            clearIdleTimer();
            startIdleTimer();
          }
        }
      }

      // Resetear el temporizador de inactividad al detectar actividad
      function resetIdleTimer() {
        var currentTime = Date.now();
        lastActivityTime = currentTime;

        // Actualizamos el localStorage para todas las pestañas
        localStorage.setItem("lastActivityTime", currentTime.toString());

        // Reiniciar el temporizador de inactividad
        clearIdleTimer();
        startIdleTimer();
      }

      // Iniciar el temporizador de inactividad
      function startIdleTimer() {
        idleTimeout = $timeout(function () {
          if (service.onIdleTimeout) {
            service.onIdleTimeout();  // Llamar a la función de desconexión
          }
        }, EXPIRATION_INACTIVITY_TIME * 60 * 1000);
      }

      // Limpiar el temporizador de inactividad
      function clearIdleTimer() {
        if (idleTimeout) {
          $timeout.cancel(idleTimeout);
        }
      }

      var destroy = function () {
        clearIdleTimer();
        removeActivityListeners();
        $window.removeEventListener("storage", handleStorageChange);
      };

      idleServiceFactory.init = init;
      idleServiceFactory.destroy = destroy;

      return idleServiceFactory;
    }]);

})();